import { useIntl } from 'react-intl-next';
import debouncePromise from 'debounce-promise';
import { utils } from '@atlaskit/util-service-support';
import { useProductContext } from '../product-router';
var SUPPORTED_LANGUAGES = /*#__PURE__*/function (SUPPORTED_LANGUAGES) {
  SUPPORTED_LANGUAGES["English"] = "en";
  return SUPPORTED_LANGUAGES;
}(SUPPORTED_LANGUAGES || {});
export var AUTOCORRECT_API_PATH = 'autocorrect';
export var DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS = 250;
export var isSupportedLanguage = function isSupportedLanguage(language) {
  return Object.values(SUPPORTED_LANGUAGES).includes(language);
};
export var sanitizeLanguage = function sanitizeLanguage(locale) {
  if (locale.includes('-')) {
    return locale.split('-')[0];
  }
  return locale;
};
export var shouldFetchAutocorrection = function shouldFetchAutocorrection(query) {
  return query.length >= 4;
};
export var useAutocorrectionEnabled = function useAutocorrectionEnabled() {
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var lang = sanitizeLanguage(locale);
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var product = getActiveProduct();
  return {
    autocorrectionEnabled: !!(product !== null && product !== void 0 && product.autocorrectEnabled) && isSupportedLanguage(lang),
    productId: (product === null || product === void 0 ? void 0 : product.id) || ''
  };
};
export var fetchAutocorrection = debouncePromise(function (_ref) {
  var query = _ref.query,
    aggregatorUrl = _ref.aggregatorUrl,
    lang = _ref.lang,
    cloudId = _ref.cloudId;
  return utils.requestService({
    url: aggregatorUrl
  }, {
    path: "".concat(AUTOCORRECT_API_PATH),
    requestInit: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: query,
        language: lang,
        cloudId: cloudId
      })
    }
  });
}, DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS);